import { App } from './app';
import { authGuard } from './shared/guards/auth.guard';

import { Routes } from '@angular/router';

export const routes: Routes = [{
    path: 'protected',
    component: App,
    canActivate: [authGuard]
  },];
